import { render, staticRenderFns } from "./table-footer.vue?vue&type=template&id=20814bb0&"
import script from "./table-footer.vue?vue&type=script&lang=js&"
export * from "./table-footer.vue?vue&type=script&lang=js&"
import style0 from "./table-footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports